import { z } from "zod";

/**
 * Compatibility wrapper for drizzle-zod insert schemas.
 *
 * drizzle-zod's type-level insert shape can omit generated/default columns that
 * older schemas still omit at runtime. This keeps the runtime omit behavior
 * without weakening the resulting schema type to `any`.
 */
export function omitSchemaFields<
  TShape extends z.ZodRawShape,
  TUnknownKeys extends z.UnknownKeysParam,
  TCatchall extends z.ZodTypeAny,
  TMask extends Record<string, true>,
>(
  schema: z.ZodObject<TShape, TUnknownKeys, TCatchall>,
  mask: TMask
): z.ZodObject<Omit<TShape, Extract<keyof TMask, keyof TShape>>, TUnknownKeys, TCatchall> {
  return schema.omit(mask as never) as z.ZodObject<
    Omit<TShape, Extract<keyof TMask, keyof TShape>>,
    TUnknownKeys,
    TCatchall
  >;
}
